import { post, get } from '../api';
import { stepsTransactions } from '../../constant/status.transactions.constant';

const purchaseRequest = async (purchaseData) =>
    post({
        type: 'user',
        service: `customers/purchase/request`,
        data: purchaseData
    });

const purchaseCreditPackage = async (purchaseData) => {
    const res = await post({
        type: 'user',
        service: `customers/purchase/credit-package`,
        data: purchaseData
    });

    return res;
}

const purchaseSubscription = async (purchaseData) =>
    post({
        type: 'user',
        service: `customers/purchase/subscription`,
        data: purchaseData
    });

const purchaseExternal = async (data) =>
    post({
        type: 'user',
        service: `customers/purchase/external`,
        data: {
            ...data,
            netPrice: getNetPrice(data.price, (data.tax || 0)),
            tax: 0
        }
    });

const findPayersByCustomer = async (customerId) =>
    get({
        type: 'user',
        service: `customers/purchase/payers/${customerId}`
    }).then(response => response.data);

const findPixPayload = async (data) =>
    post({
        type: 'user',
        service: `customers/purchase/pix-payload`,
        data
    }).then(res => res.data);

const findRecurrenceSettings = async () =>
    get({
        type: 'user',
        service: `customers/purchase/recurrence-settings`,
        data: {}
    }).then(res => res.data);

const getNetPrice = (price, tax) =>
    (parseFloat(price) - parseFloat(tax));

const findLastPurchase = () =>
    get({
        type: 'user',
        service: `customers/purchase/last-purchase`,
        data: {}
    }).then(res => res.data);

const getCustomerConversionData = (eventName, pixelID, user, transactionId, remoteAddress, trackingData = {}, eventId, eventSourceUrl) => {
    return {
        eventName: eventName,
        pixelID: pixelID,
        email: user.email,
        customerId: user.customer?.id,
        transactionId: transactionId,
        userAgent: window.navigator.userAgent,
        remoteAddress: remoteAddress,
        fbc: trackingData.fbc || getFbc(),
        fbp: trackingData.fbp || getFbp(),
        eventId: eventId,
        eventSourceUrl: eventSourceUrl,
    }
}

const submitPurchaseData = async (purchaseData) =>
    post({
        type: 'user',
        service: `customers/purchase/submit-purchase-data`,
        data: purchaseData
    }).catch(err => null);

const validateProductPurchase = async (customerId, productTypeKey, productId) =>
    post({
        type: 'user',
        service: `customers/purchase/validate-product`,
        data: { customerId, productTypeKey, productId }
    }).then(res => ({
        canPurchase: res.data.canPurchase,
        redirectUrl: res.data.redirectUrl
    }));

const generateInvoiceFile = async (transactionIds, language) =>
    post({
        type: 'user',
        service: `customers/purchase/invoice-file`,
        data: { transactionIds, language }
    })
        .then(res => res.data);

const findProviderTransaction = async (gateway, transactionId) => {
    try {
        const response = await get({
            type: 'user',
            service: `customers/purchase/transaction/${gateway}/${transactionId}`
        });

        if (!response.data) {
            return null;
        }

        const { id, status, paymentMethod } = response.data;

        const statusMap = {
            'WP': { status: stepsTransactions.WAITING_PAYMENT, payment: 'F' },
            'PA': { status: stepsTransactions.PROCESSING, payment: 'F' },
            'PC': { status: stepsTransactions.PAID, payment: 'A' },
            'PF': { status: stepsTransactions.REFUSED, payment: 'F' },
            'PR': { status: stepsTransactions.REFUSED, payment: 'F' },
            'RR': { status: stepsTransactions.PENDING_REFUND, payment: 'F' },
            'RP': { status: stepsTransactions.REFUNDED, payment: 'P' },
            'CB': { status: stepsTransactions.CHARGEDBACK, payment: 'C' }
        };

        const mappedStatus = statusMap[status] || { status: stepsTransactions.PROCESSING, payment: 'F' };

        return {
            id,
            ...mappedStatus,
            paymentMethod
        };
    } catch (error) {
        console.error('Erro ao buscar transação:', error);
        return null;
    }
};

const confirmReceiptPayment = async (transactionId) =>
    post({
        type: 'user',
        service: `financial/transactions/${transactionId}/confirm-receipt-payment`,
        data: {}
    });

const refuseReceiptPayment = async (transactionId, reason) =>
    post({
        type: 'user',
        service: `financial/transactions/${transactionId}/refuse-receipt`,
        data: { reason }
    });

const getRefundRequest = async (refundRequestId) =>
    get({
        type: 'user',
        service: `financial/refund-requests/${refundRequestId}`
    });

const approveRefundRequest = async (refundRequestId, reason) =>
    post({
        type: 'user',
        service: `financial/refund-requests/${refundRequestId}/approve`,
        data: { reason }
    });

const denyRefundRequest = async (refundRequestId, reason) =>
    post({
        type: 'user',
        service: `financial/refund-requests/${refundRequestId}/deny`,
        data: { reason }
    });

const getCookie = (name) => {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
}

const getURLParameter = (paramName) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
}

const getFbp = () =>
    getCookie('_fbp');

const getFbc = () => {

    let fbc = getCookie('_fbc');

    if (fbc)
        return fbc;

    const fbclid = getURLParameter('fbclid');
    if (fbclid) {
        // Formata o fbc conforme o padrão esperado: "fb.<n° de subdomains no url>.<timestamp>.<fbclid>"
        const timestamp = new Date().getTime();
        fbc = "fb.1." + timestamp + "." + fbclid;

        return fbc;

    }

    return null;
}

export default {
    getNetPrice,
    purchaseRequest,
    purchaseCreditPackage,
    purchaseSubscription,
    purchaseExternal,
    findPixPayload,
    findPayersByCustomer,
    findRecurrenceSettings,
    findLastPurchase,
    getCustomerConversionData,
    submitPurchaseData,
    validateProductPurchase,
    generateInvoiceFile,
    findProviderTransaction,
    confirmReceiptPayment,
    refuseReceiptPayment,
    getRefundRequest,
    approveRefundRequest,
    denyRefundRequest
}